import React from 'react';
import { Main } from "../app/main/Main";
import PolicyReport from '../app/policyReport/PolicyReport';

const PolicyReportPage = props => {
    return (<Main>
        <PolicyReport />
    </Main>
    )
}

export default PolicyReportPage;
